import {
  DEPARTURE_FILTER_PARAMS,
  DEPARTURES_PAGE_SIZE,
  departureFiltersQuery,
  type DepartureFilters,
  type DeparturesPageDto,
} from "@tripcart/shared";

/**
 * The Departure Dates block's page address (docs/features/departure-dates):
 * the filters, which `@tripcart/shared` reads and spells, plus `shown`, how
 * many departures Show more has opened. Pure, so the server section and the
 * client island read and write one address the same way.
 */

export const SHOWN_PARAM = "shown";

/** Show more stops here even with no maximum set, so one address cannot ask
 *  for an unbounded list. */
export const MAX_SHOWN = 500;

/** `shown`, rounded up to a whole step of ten; the first ten otherwise. */
export function readShown(params: Pick<URLSearchParams, "get">): number {
  const raw = params.get(SHOWN_PARAM);
  if (!raw || !/^\d+$/.test(raw)) return DEPARTURES_PAGE_SIZE;
  const steps = Math.ceil(Number(raw) / DEPARTURES_PAGE_SIZE);
  return Math.min(Math.max(steps, 1) * DEPARTURES_PAGE_SIZE, MAX_SHOWN);
}

const BLOCK_PARAMS: readonly string[] = [
  ...Object.values(DEPARTURE_FILTER_PARAMS),
  SHOWN_PARAM,
];

/**
 * The address for new filters: every parameter the block does not own is
 * kept (a preview token, a campaign tag), and `shown` starts again at ten.
 */
export function addressWithFilters(
  current: URLSearchParams,
  filters: DepartureFilters,
): string {
  const next = new URLSearchParams();
  for (const [name, value] of current) {
    if (!BLOCK_PARAMS.includes(name)) next.append(name, value);
  }
  for (const [name, value] of new URLSearchParams(
    departureFiltersQuery(filters),
  )) {
    next.append(name, value);
  }
  return next.toString();
}

/** The address of the next ten, or `null` once every match is shown. */
export function moreHrefOf(
  current: URLSearchParams,
  page: DeparturesPageDto,
  shown: number,
): string | null {
  if (page.items.length >= page.total || shown >= MAX_SHOWN) return null;
  const next = new URLSearchParams(current);
  next.set(SHOWN_PARAM, String(shown + DEPARTURES_PAGE_SIZE));
  return `?${next.toString()}`;
}
